import React from 'react';
export function HowItWorks() {
  const steps = ['Descarga el protocolo y realiza tu auto-diagnóstico de rendimiento.', 'Implementa los ajustes de nutrición y el stack de suplementos básicos.', 'Activa la rutina de potencia de 15 minutos y nota la claridad mental en menos de 7 días.'];
  return <section className="bg-navy-900 py-20 px-4 sm:px-6 lg:px-8" data-id="element-77">
      <div className="max-w-5xl mx-auto" data-id="element-78">
        <h2 className="font-playfair text-3xl sm:text-4xl font-bold text-center text-white mb-16" data-id="element-79">
          Cómo funciona
        </h2>
        <div className="grid md:grid-cols-3 gap-8 relative" data-id="element-80">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-8 left-[16%] right-[16%] h-0.5 bg-navy-700 z-0" data-id="element-81"></div>

          {steps.map((step, index) => <div key={index} className="relative z-10 flex flex-col items-center text-center" data-id="element-82">
              <div className="w-16 h-16 rounded-full bg-navy-800 border-2 border-gold-500 flex items-center justify-center text-2xl font-bold text-gold-500 mb-6 shadow-[0_0_15px_rgba(201,168,76,0.2)]" data-id="element-83">
                {index + 1}
              </div>
              <p className="text-lg text-[#e0e0e0] leading-relaxed px-4" data-id="element-84">
                {step}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}